import React from "react";
import { SendAndArchiveOutlined } from "@mui/icons-material";
import { Button, Grid, Dialog, DialogTitle, DialogContent } from "@mui/material";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { get_parameters } from "./services";
import { TextInput } from "./TextInput";
import { sha256 } from "js-sha256";

export default function DialogLogin({ check_login }) {
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const onSubmit = async ({ password }) => {
        try {
            const { data: parameters } = await get_parameters();
            if (parameters[0].password !== sha256(password)) {
                throw new Error("Wrong password");
            }
            localStorage.setItem("token", password);
            check_login();
        } catch (e) {
            console.log(e);
            toast.error("Mauvais mot de passe");
        }
    };

    return (
        <Dialog open={true} fullScreen aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">Connexion</DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} direction="column" alignItems="center" justify="center">
                        <Grid item xs={12} md={12}>
                            <TextInput
                                required
                                name="password"
                                fullWidth
                                control={control}
                                type="password"
                                label="Mot de passe"
                                helperText={errors.password?.message}
                                error={Boolean(errors.password)}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={5} paddingTop={5} direction="column" alignItems="center" justifyContent="center">
                        <Grid item xs={12}>
                            <Button variant="contained" type="submit" endIcon={<SendAndArchiveOutlined />}>
                                Connexion
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
        </Dialog>
    );
}
